const RebalanceWizardFallback = () => {
  return <h1>An unexpected error has occurred.</h1>;
};

export default RebalanceWizardFallback;
